/** Shared time-window constants derived once for the dashboard/insights. */
import { INSIGHTS } from '@mitang/shared';

export const DAY_MS = 24 * 60 * 60 * 1000;

/** Start of "today" (local midnight) in epoch ms. */
export function startOfToday(): number {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** Epoch ms N days ago from now. */
export function daysAgo(days: number): number {
  return Date.now() - days * DAY_MS;
}

/** Rolling window (ms cutoff) for "active" calculations. */
export function activeWindowStart(): number {
  return daysAgo(INSIGHTS.activeWindowDays);
}

/** Local date key (YYYY-MM-DD) for grouping a timestamp by day. */
export function dayKey(ts: number): string {
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Short label for a day key, e.g. "2026-07-18" → "18 Jul". */
export function dayLabel(key: string): string {
  const [y, m, d] = key.split('-').map(Number);
  const date = new Date(y, (m ?? 1) - 1, d ?? 1);
  return new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short' }).format(date);
}

/** The last N day keys ending today (oldest → newest). */
export function lastNDayKeys(n: number): string[] {
  const keys: string[] = [];
  for (let i = n - 1; i >= 0; i -= 1) {
    keys.push(dayKey(Date.now() - i * DAY_MS));
  }
  return keys;
}
